import { GetValidAccessToken } from '../api/refresh-token'

export default async function customFetch(
  url: string,
  config?: RequestInit | undefined
): Promise<Response> {
  if (config?.headers && 'Authorization' in config.headers) {
    const skipAuthToken = new URL(url).searchParams.get('is_public') === 'true'
    if (!skipAuthToken) {
      const token = await GetValidAccessToken()
      config.headers['Authorization'] = `Bearer ${token}`
    }
  }
  const response = await fetch(url, config)
  return response
}
